/**
 * Helper function to find a hero build by ID, supporting both legacy MongoDB (_id)
 * and new Prisma (hero_build_id) field names during the migration period.
 */
export function findHeroBuildById(heroBuilds, buildId) {
  if (!heroBuilds) {
    return undefined;
  }

  return heroBuilds.find((build) => {
    // Support both field names during migration
    return build.hero_build_id === buildId || build._id === buildId;
  });
}
